/**
 * Resume file constraints + validators. Lifted from
 * customer-app/src/pages/private-candidates/helpers.ts in Phase 7-dashboard-b
 * so the candidate dashboard (My Resumes + profile-completion gate) shares the
 * same client-side guardrails. Server enforces the same limits independently.
 */

const PDF_MIME = 'application/pdf';
const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const RESUME_PDF_MIME = PDF_MIME;
export const RESUME_DOCX_MIME = DOCX_MIME;

const ALLOWED_MIMES = new Set([PDF_MIME, DOCX_MIME]);
const ALLOWED_EXTENSIONS = ['.pdf', '.docx'];

export const RESUME_ACCEPT_ATTR =
  'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.docx';

export const RESUME_MAX_BYTES = 5 * 1024 * 1024;

/** Returns null if the file is acceptable, else a friendly error string. */
export function validateResumeFile(file: File): string | null {
  // Some browsers (Windows / older Edge) don't populate `type` for DOCX. Fall back to
  // extension when MIME is empty so we don't reject a valid DOCX upload.
  const lowerName = file.name.toLowerCase();
  const extOk = ALLOWED_EXTENSIONS.some((ext) => lowerName.endsWith(ext));
  const mimeOk = ALLOWED_MIMES.has(file.type);
  if (!extOk || (file.type && !mimeOk)) {
    return 'Only PDF and DOCX files are supported. .doc and other formats are not accepted.';
  }
  if (lowerName.endsWith('.doc') && !lowerName.endsWith('.docx')) {
    return 'Legacy .doc files are not supported. Please save as .docx or PDF and try again.';
  }
  if (file.size > RESUME_MAX_BYTES) {
    return 'Resume must be 5 MB or smaller.';
  }
  return null;
}
